import {createStore, enableElfProdMode, setProp, withProps} from '@ngneat/elf'
import {
  deleteEntities,
  getActiveEntity,
  resetActiveId,
  selectEntity,
  setActiveId,
  updateEntities,
  upsertEntities,
  withActiveId,
  withEntities,
} from '@ngneat/elf-entities'
import {devTools} from '@ngneat/elf-devtools'
import {RoomDetails} from '../messaging.types'
import {environment} from '../../../../environments/environment'
import {Inject, Injectable, PLATFORM_ID} from '@angular/core'
import {isPlatformBrowser} from '@angular/common'

@Injectable({
  providedIn: 'root',
})
export class RoomDetailStore {
  private readonly store = createStore(
    {
      name: 'chat-room-detail-store',
    },
    withEntities<RoomDetails>(),
    withActiveId(),
    withProps<{
      lastOpenedRoom?: string
    }>({}),
  )

  constructor(@Inject(PLATFORM_ID) private readonly platformId: NonNullable<unknown>) {
    if (isPlatformBrowser(this.platformId)) {
      if (environment.elf.devMode) {
        devTools()
      } else {
        enableElfProdMode()
      }
    }
  }

  roomDetailById$(roomId: string) {
    return this.store.pipe(selectEntity(roomId))
  }

  /**
   * Insert or update the given chat room detail in the store.
   */
  upsertRoom(room: RoomDetails) {
    this.store.update(upsertEntities(room))
  }

  /**
   * Remove a room from the store.
   */
  removeRoom(roomId: string) {
    this.store.update(deleteEntities(roomId))
  }

  updateUnreadCursor(roomId: string, unreadCursor: string | undefined) {
    this.store.update(updateEntities(roomId, room => ({...room, unreadCursor})))
  }

  setActiveRoom(roomId: string) {
    this.store.update(setActiveId(roomId), setProp('lastOpenedRoom', roomId))
  }

  resetActiveRoom() {
    this.store.update(resetActiveId())
  }

  getActiveRoom() {
    return this.store.query(getActiveEntity())
  }

  getLastOpenedRoom() {
    return this.store.getValue().lastOpenedRoom
  }

  reset() {
    this.store.reset()
  }
}
